import { BaseModel } from './base.model';

export class Comment extends BaseModel {
  name: string;
  date: Date;
  text: string;
  articleId?: string;
  commentResponseId?: string;
  commentResponses: Comment[];
}
